import { render, staticRenderFns } from "./responsesApproval.vue?vue&type=template&id=23669aba&"
import script from "./responsesApproval.vue?vue&type=script&lang=js&"
export * from "./responsesApproval.vue?vue&type=script&lang=js&"
import style0 from "./responsesApproval.vue?vue&type=style&index=0&id=23669aba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports